import {
  PersonMatchProfile,
  PersonProfileImageType,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUploadPersonProfileImage(
  profileId: string,
  onSuccess?: () => void,
  onError?: (err: Error) => void,
  imageType: PersonProfileImageType = 'primary'
) {
  const url = `/v2/orm/person_profile/${profileId}/upload_image?imageType=${imageType}`;

  const request = new Request(url, {
    method: 'PUT',
  });

  return useAuthenticatedMutation<PersonMatchProfile, FormData>(request, {
    onSuccessInvalidationKeys: profileId
      ? [['person_match_profiles'], ['person_match_profiles', profileId]]
      : [['person_match_profiles']],
    onSuccess,
    onError,
    getBody: (formData) => {
      const newFormData = new FormData();
      const file = formData.get('file');
      if (file) {
        newFormData.append('profileImage', file);
      }
      return newFormData;
    },
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson as PersonMatchProfile;
    },
  });
}

export default useUploadPersonProfileImage;
